<template>
  <div v-if="show" class="terms" data-qe-id="terms-modal">
    <gd-modal @closeBG="onClose" @closeESC="onClose" @close="onClose">
      <modal-app l>
        <modal-layout>
          <template v-if="isMasters">
            <terms-content-skat-masters v-if="gameType === 'ska'" />
            <terms-content-romme-masters v-if="gameType === 'rom'" />
          </template>
          <terms-content-default v-else />
        </modal-layout>
      </modal-app>
    </gd-modal>
  </div>
</template>

<script setup lang="ts">
import TermsContentDefault from './TermsContentDefault.vue'
import TermsContentRommeMasters from './TermsContentRommeMasters.vue'
import TermsContentSkatMasters from './TermsContentSkatMasters.vue'

const props = withDefaults(
  defineProps<{
    isMasters: boolean
    gameType: string
    show: boolean
  }>(),
  {
    isMasters: false,
    show: false,
  }
)
const emit = defineEmits(['close-terms'])
function onClose() {
  emit('close-terms')
}
</script>

<style lang="less">
.terms.terms {
  .gd-modal-component-body {
    overflow-y: scroll;
  }
  .terms-text {
    text-align: justify;
  }
}
</style>
